var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import GenericTable from "../../../../../../../shared-library/components/GenericTable";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
import { textConfig } from "@frameworks/salesjourney/components/Features/ClientDetails/constant";
var EdisDetails = function (props) {
    var _a = __read(useState(null), 2), poaEdis = _a[0], setPoaEdis = _a[1];
    var selectedAccount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    useEffect(function () {
        if (selectedAccount && selectedAccount.accountCode)
            di.clients
                .POAEdis({ acCode: selectedAccount.accountCode })
                .then(function (val) {
                setPoaEdis(val);
            });
    }, [selectedAccount]);
    var edisColumns = [
        {
            columnName: "Client Code",
            key: "accountCode",
        },
        {
            columnName: "ISINCode",
            key: "isinCode",
        },
        {
            columnName: "Quantity",
            key: "quantity",
        },
        {
            columnName: "PlatFormEdis",
            key: "platFormEdis",
        },
        {
            columnName: "DBUploadStatus",
            key: "dbUploadStatus",
        },
        {
            columnName: "DBUploadRemark",
            key: "dbUploadRemark",
        },
        {
            columnName: "DBUploadDatetime",
            key: "dbUploadDatetime",
        },
    ];
    return (React.createElement(Row, { className: "mx-0 px-0 dpledger-block" },
        React.createElement(Row, { className: "px-0 mx-0" },
            React.createElement(Col, { className: "px-0 HeadRow d-flex justify-content-between align-items-center" },
                React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                    React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                            props.closePopup(false);
                        } }),
                    "EDIS Details"))),
        React.createElement("div", { className: "padding-30 " },
            React.createElement(GenericTable, { columns: edisColumns, data: poaEdis, parentClassName: "common-modal-table" })),
        (poaEdis === null || poaEdis === void 0 ? void 0 : poaEdis.length) < 1 && (React.createElement("div", { className: "EncodeSansN_20_400 d-flex justify-content-center" }, textConfig.NoDataFound))));
};
export default EdisDetails;
